import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]"></p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Web Developer"
            subTitle="MENTAPPS SOLUTIONS"
            result="Ikeja"
            des="Creating all aspects of clients website, from start to finish."
          />
          <ResumeCard
            title="Web Developer"
            subTitle="OPERA ADS"
            result="Opebi,Ikeja"
            des="Team Lead."
          />
          <ResumeCard
            title="Web Developer"
            subTitle="Global Buy - (2021 - Present)"
            result="Ikeja"
            des="Creating all aspects of clients website, from start to finish."
          />
        </div>
      </div>
      <div />
      <div className="flex flex-col gap-4">
        <p className="text-sm text-designColor tracking-[4px]"></p>
        <h2 className="text-4xl font-bold">Trainer</h2>
      </div>
      <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
        <ResumeCard
          title="WEB,DIGITAL MARKETING TRAINING"
          subTitle="Dammietech Solutions"
          result="Ogba"
          des="The WEB DESIGN & DIGITAL MARKETING TRAINING REGISTRATION"
        />
        <ResumeCard
          title="Web Design Training"
          subTitle="Dammietech Solutions"
          result="Ogba"
          des="We Offer Professional Training in Web Design."
        />
        <ResumeCard
          title="WEB,DIGITAL MARKETING TRAINING"
          subTitle="Dammietech Solutions"
          result="Ogba"
          des="We Offer Professional Training in Web Design and Digital Marketing"
        />
      </div>
      <div />
    </motion.div>
  );
};

export default Experience;
